import { useState } from "react";
import { RESET_PASSWORD_ROUTE } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";

export const useResetPassword = () => {
    const [isLinkSent, setIsLinkSent] = useState(false);
    const [resetPasswordState, { post }] = useFetch();

    const resetPassword = () => {
        setIsLinkSent(false);

        post<boolean>(RESET_PASSWORD_ROUTE).then((resetPasswordResponse) => {
            if (resetPasswordResponse) {
                setIsLinkSent(true);
            }
        });
    };

    return { resetPasswordState, resetPassword, isLinkSent };
};
